import React from 'react';
import {
  // eslint-disable-next-line no-restricted-imports
  Text as RNText,
  TextProps as RNTextProps,
  TextStyle,
  StyleProp,
  StyleSheet,
  GestureResponderEvent,
} from 'react-native';
import { IS_ANDROID } from '@/utils/platform';

import { styles } from './styles';

interface TextProps extends RNTextProps {
  style?: StyleProp<TextStyle>;
  ref?: React.ForwardedRef<RNText>;
  children: React.ReactNode;
  onPress?: (event: GestureResponderEvent) => void;
  androidTrailingSpace?: boolean;
}
const isBoldWeight = (fontWeight?: TextStyle['fontWeight']): boolean =>
  fontWeight === 'bold' || Number(fontWeight) >= 600;

const resolveBoldFont = (
  style?: StyleProp<TextStyle>,
): StyleProp<TextStyle> => {
  if (!style) {
    return style;
  }

  const { fontFamily, fontWeight } = StyleSheet.flatten(style);

  if (fontFamily && fontFamily !== 'Inter') {
    return style;
  }

  return isBoldWeight(fontWeight)
    ? [style, { fontFamily: 'InterSemiBold' }]
    : style;
};

export const Text: React.FC<TextProps> = ({
  style,
  ref,
  children,
  onPress,
  androidTrailingSpace = true,
  ...rest
}) => {
  return (
    <RNText
      onPress={onPress}
      style={[styles.defaultText, resolveBoldFont(style)]}
      ref={ref}
      allowFontScaling={false}
      {...rest}
    >
      {children}
      {IS_ANDROID && androidTrailingSpace ? ' ' : null}
    </RNText>
  );
};
